export const logoutUser = gql`
    mutation logoutUser {
        logout {
            status
            message
        }
    }
`
